import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { VinSightsRepositoryService } from '../../services/vinsights/vinsights-repository.service';
import { OrderManagerService } from '../../services/order-manager/order-manager.service';
import { Subject, takeUntil } from 'rxjs';
import { Order } from '../../interfaces/orders/order';
import { RawVinSights, VinSights } from '../../interfaces/vinsights';
import { MatDialog } from '@angular/material/dialog';
import { VinSightDetailsComponent } from '../vinsight-details/vinsight-details.component';
import { eResultState } from '../../enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-vinsights',
    templateUrl: './vinsights.component.html',
    styleUrl: './vinsights.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VinSightsComponent implements OnInit, OnDestroy {
  private readonly transloco = inject(TranslocoService);

  order!: Order
  vinSights?: VinSights | null = null;
  hasVinsights = false;
  private unsubscribe$ = new Subject<void>();

  get firstNote(): string {
    return this.vinSights?.vinSights[0] || this.transloco.translate('vinsights.noIrregularitiesFound');
  }

  get count(): number {
    return this.vinSights?.vinSights.length ?? 0;
  }

  constructor(private vinSightRepo: VinSightsRepositoryService,
    private orderManager: OrderManagerService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.orderManager.currentOrder
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(order => {
        this.order = order

        if (this.shouldHaveVinsights()) {
          var parsedResultID = order.searchResult?.parsedResultID;
          
          if (parsedResultID) {
            this.vinSightRepo.getVinSights(order.id, parsedResultID).subscribe(result => {
              this.vinSights = this.parseVinSights(result);
              this.hasVinsights = true;
            })
          }
        }
      });
  }

  private parseVinSights(raw: RawVinSights): VinSights {
    try {
      // parse the JSON-string and tell TS “this is a VinSights”
      return JSON.parse(raw.vinSights) as VinSights;
    } catch (e) {
      throw new Error('invalid vinSights JSON');
    }
  }

  shouldHaveVinsights() {
    return this.order.searchResult?.resultState !== undefined &&
      this.order.searchResult?.resultState !== null &&
      this.order.searchResult.resultState.id !== eResultState.noResult;
  }

  openVinSights() {
    this.dialog.open(VinSightDetailsComponent, {
      data: this.vinSights,
      minWidth: '1000px'
    })
  }

  ngOnDestroy(): void {
    // Signal all subscriptions to complete
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
